const isProd = process.env.NODE_ENV === 'production'
const istest = process.env.NODE_ENV === 'test'

let API_HEADER = ''
let DataApiUrl = ''

if (isProd) {
  API_HEADER = accountConfig.API_HEADER || 'https://accountc.xyabcd.com'
  DataApiUrl =
    accountConfig.DataApiUrl || 'http://dataapi.xyabcd.com/datacenterservice'
} else if (istest) {
  API_HEADER = 'http://test.accountcenter.com'
  DataApiUrl = 'http://192.168.0.226:30005/datacenterservice'
} else {
  API_HEADER = accountConfig.API_HEADER || 'http://test.accountcenter.com'
  // DataApiUrl = 'http://192.168.0.226:30005/datacenterservice'
  // API_HEADER = 'http://localhost:3004'
  DataApiUrl = 'http://192.168.0.226:30005/datacenterservice'
}
export default {
  API_HEADER,
  DataApiUrl
}
